import { STEPS } from '../../components/teams/perks/giftCardUtils'
import { pushSnowplow, toTeamsFeatureSchema } from '../snowplow'
import { ACTION_TARGETS, ACTION_TARGET_TYPES, ACTION_TYPES, VIEWS, VIEW_TYPES } from './teamsEvents'

export const publishClickedSendGift = memberIds =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.MEMBERS,
      VIEW_TYPES.TABLE,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.SEND_GIFTS,
      ACTION_TARGET_TYPES.BUTTON,
      memberIds,
    ),
  )

export const publishViewed = view =>
  pushSnowplow(toTeamsFeatureSchema(view, VIEW_TYPES.DIALOG, ACTION_TYPES.VIEWED))

export const publishClickedNext = (view, error) =>
  pushSnowplow(
    toTeamsFeatureSchema(
      view,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.NEXT,
      ACTION_TARGET_TYPES.BUTTON,
      undefined,
      error,
    ),
  )

export const publishClickedBack = view =>
  pushSnowplow(
    toTeamsFeatureSchema(
      view,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.BACK,
      ACTION_TARGET_TYPES.BUTTON,
    ),
  )

export const publishClickedClose = view =>
  pushSnowplow(
    toTeamsFeatureSchema(
      view,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.CLOSE,
      ACTION_TARGET_TYPES.BUTTON,
    ),
  )

export const publishClickedExcludeGiftRecipient = memberId =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.STEP_GIFT_RECIPIENTS,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.EXCLUDE,
      ACTION_TARGET_TYPES.BUTTON,
      memberId,
    ),
  )

export const publishClickedPurchaseGifts = (memberIds, error) =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.STEP_GIFT_CHECKOUT,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.PURCHASE,
      ACTION_TARGET_TYPES.BUTTON,
      memberIds,
      error,
    ),
  )

export const publishClickedConfirmClose = step =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.CLOSE_GIFT_DIALOG,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.CONFIRM,
      ACTION_TARGET_TYPES.BUTTON,
      step,
    ),
  )

export const publishChangedInput = (actionTarget, value, error) =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.STEP_GIFT_DETAILS,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CHANGED,
      actionTarget,
      ACTION_TARGET_TYPES.INPUT,
      value,
      error,
    ),
  )

export const publishClickedGiftAmount = (value, error) =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.STEP_GIFT_DETAILS,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.GIFT_AMOUNT,
      ACTION_TARGET_TYPES.RADIO,
      value,
      error,
    ),
  )

// ------------------------------------
// Utils
// ------------------------------------
export const getViewByStep = step => {
  switch (step) {
    case STEPS.GIFT_DETAILS:
      return VIEWS.STEP_GIFT_DETAILS
    case STEPS.GIFT_RECIPIENTS:
      return VIEWS.STEP_GIFT_RECIPIENTS
    case STEPS.GIFT_ADD_PAYMENT:
      return VIEWS.STEP_GIFT_ADD_PAYMENT
    case STEPS.GIFT_PAYMENT:
      return VIEWS.STEP_GIFT_CHECKOUT
    default:
      console.error('Invalid step name.')
  }
}
